import { render, staticRenderFns } from "./MarketingSection.vue?vue&type=template&id=532441a4&scoped=true"
import script from "./MarketingSection.vue?vue&type=script&lang=js"
export * from "./MarketingSection.vue?vue&type=script&lang=js"
import style0 from "./MarketingSection.vue?vue&type=style&index=0&id=532441a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532441a4",
  null
  
)

export default component.exports